<div style="font-size: 24px; text-align: center; line-height: calc(100vh - 24px)">Application is loading...</div>
